<div class="relative" *transloco="let t" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragBoundary=".cdk-overlay-container">
	<button class="absolute right-2 top-2 z-10" mat-icon-button (click)="close(false)" [attr.aria-label]="t('commonActions.close')">
		<mat-icon>close</mat-icon>
	</button>
	<div class="cursor-move px-6 pt-4 pr-12 text-lg font-semibold" cdkDragHandle>
		{{ t(filterDialogData.translationPrefix + 'filterDialogTitle') }}
	</div>
	<mat-dialog-content>
		@if (!filterDialogData.finishedLoading) {
			<div class="spinner-style" style="position: relative">
				<mat-progress-spinner color="primary" mode="indeterminate"></mat-progress-spinner>
			</div>
		} @else {
			<div class="flex flex-col">
				<div style="max-height: 500px; overflow: scroll">
					@for (filter of filterDialogData.filterDialogProperties; track filter.key) {
						<ara-search-select
							(newFilters)="addFilter(filter.key, $event)"
							[dataMultiCtrl]="filter.selectedValuesFC"
							[data]="filter.values"
							[label]="filter.label"
							[preSetCheckedData]="filter.preSetCheckedData"
							[skipEnumTranslation]="filter.skipEnumTranslation"
							[translationEnumPrefix]="filter.translationEnumPrefix"></ara-search-select>
					}
				</div>
			</div>
		}
		<ng-container>
			<div class="flex flex-row justify-end items-center" mat-dialog-actions>
				<button (click)="close(true)" color="primary" mat-raised-button type="submit">
					<mat-icon>check</mat-icon>
					@if (!isMobile) {
						<span>{{ t('common.apply') }}</span>
					}
				</button>
			</div>
		</ng-container>
	</mat-dialog-content>
</div>
